<template>
  <wk-header :currentIndex="4"></wk-header>
  <el-main style="padding-bottom: 80px">
    <el-row >
      <img src="./../assets/img/banner.webp" class="wk-banner">
      <div class="wk-banner-title">
        <div>
          <h2 style="font-size: 4.5em">嗨微客</h2>
          <h2 class="title_desc">
            <span>行业工具一网扫尽</span>
            <span>行业资讯一览无遗</span>
          </h2>
          <!-- <h3>嘟聪嗨微客您创业的好助手</h3> -->
        </div>
      </div>
    </el-row>
    <el-row>
      <el-col :span="18" :offset="3">
        <h1 class="center">腾讯地图</h1>
        <div id="containerId" style="width:1200px;height:600px;"></div>
      </el-col>
    </el-row>
  </el-main>
  <wk-footer></wk-footer>
</template>
<script>
import WkHeader  from '@/components/WKHeader'
import WkFooter from '@/components/WKFooter'
export default {
  name: 'Map',
  components: {
    WkHeader,
    WkFooter
  },
  data(){
    return{
      customGeometries:[
          {
            "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            "styleId": 'myStyle',  //指定样式id
            "position": new window.TMap.LatLng(36.00204,119.895135),  //点标记坐标位置
            "properties": {//自定义属性
                "title": "<div>青岛西海岸润诚法律服务所</div><div>地址：山东青岛</div><div>电话：18562736555</div><div>负责人：邵华</div>"
            }
          }, 
          {//第二个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.688188,119.86036),
            "properties": {
                "title": "<div>青岛西海岸琅琊法律服务所</div><div>山东青岛</div><div>电话：13608971992</div><div>负责人：张茂辉</div>",
            }
          },
          {//第3个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.80526,119.725846),
            "properties": {
                "title": "<div>青岛西海岸大村法律服务所</div><div>山东青岛</div><div>电话：13854234992</div><div>负责人：王军友</div>",
            }
          },     
          {//第4个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.931593,120.008807),
            "properties": {
                "title": "<div>青岛西海岸临港法律服务所</div><div>山东青岛</div><div>电话：13668897397</div><div>负责人：张 钢</div>",
            }
          }, 
          {//第5个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.94078,120.140892),
            "properties": {
                "title": "<div>青岛西海岸灵山卫法律服务所</div><div>山东青岛</div><div>电话：15964280444</div><div>负责人：王 磊</div>",
            }
          },
          {//第6个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.758436,119.824617),
            "properties": {
                "title": "<div>青岛西海岸仁正法律服务所</div><div>山东青岛</div><div>电话：13695426038</div><div>负责人：李世昌</div>",
            }
          },   
          {//第7个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.659255,119.569734),
            "properties": {
                "title": "<div>青岛西海岸海青法律服务所</div><div>山东青岛</div><div>电话：13969646108</div><div>负责人：徐敬芹</div>",
            }
          },   
          {//第8个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.5724,120.1129),
            "properties": {
                "title": "<div>青岛西海岸德倡法律服务所</div><div>山东青岛</div><div>电话：13687618838</div><div>负责人：张 杰</div>",
            }
          }, 
          {//第9个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.702902,119.786096),
            "properties": {
                "title": "<div>青岛西海岸泊里法律服务所</div><div>山东青岛</div><div>电话：13345021533</div><div>负责人：董俊录</div>",
            }
          },  
          {//第10个点标记
            "id": "2",
            "styleId": 'myStyle',
            "position": new window.TMap.LatLng(35.821485,119.976986),
            "properties": {
                "title": "<div>青岛西海岸大珠山法律服务所</div><div>山东青岛</div><div>电话：13385426880</div><div>负责人：孙学明</div>",
            }
          },                                   
      ]
    }
  },
  mounted(){
    // this.init();
  },
  methods:{
    init(){
      let that = this;
      //定义地图中心点坐标
      let center=new window.TMap.LatLng(35.960498,120.19791)     
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      let map = new window.TMap.Map(document.getElementById('containerId'), {
          center: center,//设置地图中心点坐标
          zoom:11.1,   //设置地图缩放级别
          viewMode:'2D',//3D / 2D 显示模式控制
      });  
      //创建并初始化MultiMarker
      let markerLayer = new window.TMap.MultiMarker({
        map: map,  //指定地图容器
        //样式定义
        styles: {
            //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
            "myStyle": new window.TMap.MarkerStyle({ 
                "width": 25,  // 点标记样式宽度（像素）
                "height": 35, // 点标记样式高度（像素）
                "src": 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',  //图片路径
                //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                "anchor": { x: 16, y: 32 }  
            }) 
        },
        //点标记数据数组
        geometries: that.customGeometries,
      });

      let yxlsswssd = new window.TMap.LatLng(35.977393,120.180613);//山东盈祥律师事务所

      //初始化infoWindow
      var infoWindow = new window.TMap.InfoWindow({
          map: map,
          position: yxlsswssd,
          offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素，为了使其显示在Marker的上方
      });
      infoWindow.close();//初始关闭信息窗关闭
      //监听标注点击事件
      markerLayer.on("click", function (evt) {
          //设置infoWindow
          infoWindow.open(); //打开信息窗
          infoWindow.setPosition(evt.geometry.position);//设置信息窗位置
          infoWindow.setContent(evt.geometry.properties.title);//设置信息窗内容

      })      

    }
  }
}
</script>

<style scoped>
.el-main {
  padding-left: 0;
  padding-right: 0;
}
.wk-banner {
  width: 100%;
  position: relative;
}
.wk-banner-title {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
}
.wk-banner-title h1 {
  font-size: 5em;
}
.wk-banner-title h3 {
  font-size: 2.5em;
  margin-top: 0.5em;
  font-weight: normal;
}
.gray.l5 {
  line-height: 1.8em;
  padding-right: 12%;
}
.about-second {
  position: relative;
  background-color: #DCE2EA;
  padding: 40px 5%;

}
.about-second::before {
  content: '';
  position: absolute;
  height: 100%;
  width: 30%;
  background-color: #DCE2EA;
  opacity: 0.5;
  left: -30%;
  top: 0;

}
.about-second h3 {
  margin-top: 20px;
}

.about-second > h3::before {
  content: '';
  display: inline-block;
  width: 0.4em;
  height: 0.4em;
  background-color: #1E87FF;
  margin-right: 10px;
  vertical-align: middle;
  transform: rotate(45deg) translateY(-50%);
}
.about-third {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.5%;
  background-color: #F5F5F5;
}
.about-third .center> img {
  width: 100px;
}
.el-col h1 {
  margin-top: 80px;
}
.title_desc {
  font-size: 3.5em;
}
.title_desc span {
  display: inline-block;
}
.title_desc span:last-child {
  margin-left: 1em;
}
</style>
